import baseReport from '../baseReport';
import Meses from "@/utils/dias";
import formatDataBR from '@/plugins/filters/formatDataBR';

const reportFrequenciaDia = async ({ date, time, filtros, aulas, data, disciplinas, professores }) => {
  const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Registro de Frequência por Dia' }, 'landscape');

  let nameProfessores = professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, "");
  nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);

  const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    {
      fontSize: 9,
      text: [{ text: "Professor/Educador:   ", bold: true }, nameProfessores],
      margin: [0, 0, 0, 3]
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [ { text: 'Ano letivo:  ', bold: true }, filtros.aaletivo ],
        },
        {
          alignment: "right",
          text: [{ text: "Turma:   ", bold: true }, filtros.nmturma]
        }
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          alignment: "right",
          text: [{ text: "Período:   ", bold: true }, filtros.dspravadi]
        }
      ],
    },
  ];

  const montarAlunoHeader = (aluno, modeloAulas) => {
    let mesAnterior = '';
    let mes;

    return [
      [
        {
          text: [ {text: `${aluno.nmaluno}`, bold: true, margin: [20,20,20,20]}, {bold: false, italics:true, fontSize:7, margin: [20,30,20,20] ,text: `\nDt Enturmação: ${formatDataBR(aluno.dtsitalun)}${aluno.situacao_fim ? ` - ${aluno.situacao_fim.dssitalun}` : ""}` + `${aluno.dtafastam ? ` - ${formatDataBR(aluno.dtafastam)}` : ""}`}],
          style: "tableHeader"
        },
        ...modeloAulas.map( data => {
          mes = data.substr(5, 2)
          if (mes != mesAnterior) {
            mesAnterior = mes;
            return {
              text: `${Meses.mesesMin[mes - 1]}`,
              alignment: "center",
              colSpan: modeloAulas.filter(n => n.substr(5, 2) === mes).length,
              bold: true,
              style: "tableHeader",
            }
          }
          return {}
        }),
        {
          text: 'Faltas por Disc/ Campos de Experiência',
          alignment: "center",
          bold: true,
          style: "tableHeader",
        },
      ],

    ];
  };

  const montarHeaderDia = (aluno, modeloAulas) => {
    let mesAnterior = '';
    let mes;

    return [
      [
        {
          text: 'Disciplina/Campos de Experiência',
          bold: true,
          style: "tableSubHeader"
        },
        ...modeloAulas.map( data => {
          return (
           {
            text: parseInt(data.substr(8,2)),
            alignment: "center",
            fontSize: 6,
            margin: [-4, 0, -4, 0],
            bold: true,
            style: "tableSubHeader"
            }) }
          ),
        {text: '', style: "tableSubHeader"},
      ]
    ];
  };

  const montarDisciplinaLinha = (aluno, modeloAulas, disciplinas) => {
    let faltasPorDia = {};
    let linhas = [];


    for (const disciplina of disciplinas) {
      let faltasPorDisciplina = 0;

      const linha = [
        {text: `${disciplina.dsdiscipl}`},


        ...modeloAulas.map( aula => {
          faltasPorDia[aula] = 0;

          for (const falta of aluno.faltas) {
            if (aula == falta.dataaula) {
              faltasPorDia[aula] += falta.qnt;

              if (falta.cddiscipl == disciplina.cddiscipl) {
                faltasPorDisciplina += falta.qnt
                return ({ text: falta.qnt > 0 ? falta.qnt : "-", alignment: "center" });
              }
            }
          }
          return {text: '', alignment: "center", fillColor: '#eeeeee'}
        }),

        {text: faltasPorDisciplina, alignment: "center", bold: true}
      ];

      linhas.push( linha );
    }

    let totalPorDia = [...Object.values(faltasPorDia).map( value => ({text:value, italics: true, bold: true, alignment: 'center'}) )];

    linhas.push( [{text: 'Faltas por Dia', italics: true, bold: true, margin: [20, 0, 0, 0]}, ...totalPorDia, {}]);

    let totalPorMes = montarTotalMes(faltasPorDia, modeloAulas);

    linhas.push( ...totalPorMes);

    return linhas;
  };

  const montarTotalMes = (faltasPorDia, modeloAulas) => {
    let totaisPorDia = [...Object.values(faltasPorDia)];
    let totais = {};
    let mesAnterior = '';

    modeloAulas.forEach( (aula, i) => {
      let mes = aula.substr(5,2);

      if (mes != mesAnterior) {
        mesAnterior = mes;
        totais[mes] = {};
        totais[mes].total = 0;
        totais[mes].qtDias = 0;
      }

      totais[mes].total += totaisPorDia[i];
      totais[mes].qtDias += 1;

    });

    let totaisPorMes = [];

    Object.keys(totais).forEach(mes => {
      totaisPorMes.push({text: totais[mes].total, colSpan: totais[mes].qtDias, alignment: 'center', italics: true, bold: true, fillColor: '#ff7878'});
      for(let i = 1; i < totais[mes].qtDias; i++) {
        totaisPorMes.push({});
      }
    });

    return [
      [
        {text: 'Faltas por Mês', italics: true, bold: true, margin: [20, 0, 0, 0]},

        ...totaisPorMes,

        {},
      ]
    ];
  };


  if (aulas.length <= 0 ) {
    return {
      ...headerFooter,
      content: [
        ...filtrosFormated,
        {
          text: "Nenhuma frequência encontrada.",
          fontSize: 10,
          alignment: "center",
          margin: [0, 15, 0, 0],
          bold: true
        }
      ]
    };
  }

  data.map(aluno => {
    aluno.faltasCopia = aluno.faltas;
  })

  const periodoFormated = filtros.periodos.map( (p, i) => {

    let modeloAulas = [];
    for (let aula of aulas)
    {
      if (aula.cdpravadi == p.key)
      {
        modeloAulas[aula.dataaula] = true;
      }
    }
    modeloAulas = Object.keys(modeloAulas);

    let result = [];

    let alunos = data.map( aluno => {
      aluno.faltas = aluno.faltasCopia;
      aluno.faltas = aluno.faltas.filter( falta => falta.cdpravadi == p.key);
      return aluno;
    });

    alunos.forEach(aluno => {
      result.push(...montarAlunoHeader(aluno, modeloAulas));
      result.push(...montarHeaderDia(aluno, modeloAulas));
      result.push(...montarDisciplinaLinha(aluno, modeloAulas, disciplinas));
    });

    return [
      {
        text: `Período Avaliativo: ${p.value}`,
        alignment: "center",
        bold: true,
        margin: [0, 10, 0, 10],
        fontSize: 10
      },
      {
        margin: [0, 0, 0, 10],
        fontSize: 7,
        table: {
          widths: [
            { width: "*" },
            ...modeloAulas.map(() => ({ width: "0.13%" })),
            { width: 70, fontSize: 6 },
          ],
          body: [
            ...result
          ]
        },
        pageBreak: filtros.periodos.length == i+1 ? "" : "after"
      }
    ];
  });

  return {
    ...headerFooter,
    content: [
      ...filtrosFormated,
      ...periodoFormated,
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 7,
        color: 'black',
        fillColor: '#D3D3D3'
      },
      tableSubHeader: {
        bold: true,
        fontSize: 7,
        color: 'black',
        fillColor: '#eeeeee'
      },
    }
  };
};

export default reportFrequenciaDia;
